import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function About() {
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' }, p: 3 }}>
      <Typography variant="h4" gutterBottom>
        About Us
      </Typography>

      <Typography variant="body1" paragraph>
        {/* Placeholder — replace with content from product team */}
        Lorem ipsum paragraph one...
      </Typography>

      <Typography variant="body1" paragraph>
        {/* Placeholder — replace with content from product team */}
        Lorem ipsum paragraph two...
      </Typography>
    </Box>
  );
}

